import { useState, useEffect } from "react";

import { apiHost } from "../consts";

const defaultFlags = {
  avatarEditorEnabled: false,

  likesTest: false,
  contentLists: false,
  commentsEnabled: false,
  contactsSharingEnabled: false,

  editorialTest: false,
  topicsTest: false,
  moderationEnabled: false,
  moderatorialCommentsEnabled: false,

  legacyMobileDetection: false,

  menuHeaderTest: false,
  notificationsTest: true,

  autosaveEnabled: false,

  // Задаются на бэкенде переменными окружения, не строками Flag
  contentEditingPaused: false,
  maintenanceModeEnabled: false,
} as const;

type Flags = Record<keyof typeof defaultFlags, boolean>;

let flags: Flags = { ...defaultFlags };
let loading = true;

const setFlags = (newFlags: Partial<Flags>) => {
  flags = { ...flags, ...newFlags };
};

// Fetch once on module load
fetch(`${apiHost}/solutions/api/flags/`, { credentials: "include" })
  .then((res) => (res.ok ? res.json() : {}))
  .then((data) => {
    setFlags(data);
    loading = false;
  })
  .catch(() => {
    loading = false;
  });

export const useFlags = () => {
  const [state, setState] = useState({ flags, loading });

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        if (!loading) {
          setState({ flags, loading: false });
          clearInterval(interval);
        }
      }, 50);

      return () => clearInterval(interval);
    }
  }, []);

  return state;
};

export const useFlag = (flagName: keyof Flags): boolean => {
  const { flags } = useFlags();

  return flags[flagName] ?? false;
};
